const ALERT_MAP = {
    values: [
        {
            name: "Low Inventory",
            code: "low_inventory",
            icon: "product",
            sev: "CRITICAL",
            input: {
                threshold: 50,
                type: "number",
                valueType: "percent",
                label: "Percent of items"
            },
            limitedTo: ["site"]
        },
        {
            name: "Reload Shelf",
            code: "reload_shelve",
            icon: "cachedIcon",
            sev: "CRITICAL",
            input: {
                threshold: 50,
                type: "number",
                valueType: "percent",
                label: "Percent of items"
            }
        },
        {
            name: "Zero Line",
            code: "zero_line",
            icon: "powerInputIcon",
            sev: "CRITICAL",
            input: {
                threshold: 2,
                type: "number",
                valueType: "number",
                label: "Number of items"
            }
        },
        {
            name: "Misplaced Product",
            code: "planograma_relograma",
            icon: "locationOffIcon",
            sev: "WARNING"
        }
    ],
    eventMainTypes: {
        SHELF_BOUNCER: "SHELF_BOUNCER"
    },
    eventTypes: {
        PLANOGRAM_NOT_VALID: {
            title: "Misplaced Product"
        },
        PLANOGRAM_NOT_CONFIGURED: {
            title: "Planogram not configured",
        },
        ZERO_LINE: {
            title: "Zero Line"
        },
        RELOAD_SHELF: {
            title: "Reload Shelf"
        },
        LOW_INVENTORY: {
            title: "Low Inventory",
        },
        PRODUCT_NOT_DETECTED_ON_RETURN: {
            title: 'Return product',
        },
        PICK_DOWN_PRODUCT: {
            title: 'Return product',
        },
        PRODUCT_NOT_DETECTED_ON_PICK_UP: {
            title: "Pick up product'",
        },
        PICK_UP_PRODUCT: {
            title: "Pick up product'",
        },
        MANUAL_EDIT_INVENTORY: {
            title: "Edit inventory",
        },
        SIGMA_BUSKET: {
            title: "Sigma basket",
        }
    },
    eventTypesList: {
        MANUAL_EDIT_INVENTORY: "MANUAL_EDIT_INVENTORY",
        PRODUCT_NOT_DETECTED_ON_RETURN: "PRODUCT_NOT_DETECTED_ON_RETURN",
        PICK_DOWN_PRODUCT: "PICK_DOWN_PRODUCT",
        PRODUCT_NOT_DETECTED_ON_PICK_UP: "PRODUCT_NOT_DETECTED_ON_PICK_UP",
        PICK_UP_PRODUCT: "PICK_UP_PRODUCT",
        PLANOGRAM_NOT_VALID: 'PLANOGRAM_NOT_VALID',
        ZERO_LINE: 'ZERO_LINE',
        RELOAD_SHELF: 'RELOAD_SHELF',
        PLANOGRAM_NOT_CONFIGURED: 'PLANOGRAM_NOT_CONFIGURED',
        LOW_INVENTORY: 'LOW_INVENTORY',
        SIGMA_BUSKET: 'SIGMA_BUSKET'
    },
    severity: {
        CRITICAL: "High",
        WARNING: "Medium",
        INFO: "Low"
    },
    severities: {
        CRITICAL: "CRITICAL",
        WARNING: "WARNING",
        INFO: "INFO"
    },
    eventEntitys: {
        LOG: "LOG",
        ALERT: "ALERT",
    },
    statuses: {
        PENDING: "PENDING",
        ACTIVE: "ACTIVE",
        HANDLING: "HANDLING",
        HANDLED: "HANDLED",
        CLOSED: "CLOSED",
        SILENCED: "SILENCED"
    }
};

export default ALERT_MAP;